import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname, hash]);

  useEffect(() => {
    const handleClick = (e) => {
      const anchor = e.target.closest("a[href]");
      if (!anchor) return;

      const isExternal = anchor.hostname !== window.location.hostname;
      const opensInNewTab = anchor.target === "_blank";
      if (isExternal || opensInNewTab) return;

      const url = new URL(anchor.href);
      const current = window.location;

      const samePath = url.pathname === current.pathname;
      const noHash = !url.hash && !current.hash;

      if (samePath && noHash) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
}